module.exports = __webpack_public_path__ + "static/media/asset-management.36ecf2d3.svg";